// extracted by mini-css-extract-plugin
module.exports = {"box":"Layout_box__2nC5r","header":"Layout_header__3Owl7","nav":"Layout_nav__1_H55","selectedIcon":"Layout_selectedIcon__tUO_1","unselectedIcon":"Layout_unselectedIcon__1Ninb"};